// extracted by mini-css-extract-plugin
export default {"card":"card_card__nGh8t","oneHalf":"card_oneHalf__3uJJx","oneThird":"card_oneThird__T41YI","twoThirds":"card_twoThirds__X6S7T","noVerticalPadding":"card_noVerticalPadding__2jYLK"};